import { ApplicationEnvironment } from './application-environment';

export const environment: ApplicationEnvironment = {
    firebase: {
        projectId: 'queuest-cb885',
        appId: '1:936633637141:web:9cc171d2c3bf1f5a5bb11c',
        storageBucket: 'queuest-cb885.appspot.com',
        apiKey: 'AIzaSyDPU4uUi8KAm_2VC1kZg7oIlPpQJvV7MQY',
        authDomain: 'queuest-cb885.firebaseapp.com',
        messagingSenderId: '936633637141',
        measurementId: 'G-P8DPMCNH7X',
    },
    production: true,
    application: {
        apiUrl: 'https://api.queuest.c7d5a6.com',
    },
};
